import { render, staticRenderFns } from "./vessels-reports-add-or-edit.vue?vue&type=template&id=0caeafc4&scoped=true"
import script from "./vessels-reports-add-or-edit.vue?vue&type=script&lang=js"
export * from "./vessels-reports-add-or-edit.vue?vue&type=script&lang=js"
import style0 from "./vessels-reports-add-or-edit.vue?vue&type=style&index=0&id=0caeafc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caeafc4",
  null
  
)

export default component.exports